import { Outlet } from 'react-router-dom';

const PlacePage = () => {
  return <Outlet />;
};

export default PlacePage;
